import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { enTranslations } from './en'
import { esTranslations } from './es'
import { frTranslations } from './fr'
import { initialLanguageFromLocation } from './locale-history'

/**
 * The URL decides the language, and it must decide it BEFORE the first render.
 *
 * `/en/about` is an English URL — a crawler, a shared link or a bookmark must
 * get English from it whatever `localStorage` or `navigator.language` say, and
 * `/about` must likewise get French. Passing `lng` to `init()` short-circuits
 * the detector entirely on the public surface, so there is no window in which
 * the persisted language renders first and gets corrected a tick later.
 *
 * On the admin back-office (`/manage/...`), which has no locale-addressed
 * URLs, `undefined` is passed and the detector keeps its usual behaviour: the
 * signed-in user's own remembered preference.
 */
const initialLanguage = initialLanguageFromLocation(
  typeof window === 'undefined' ? undefined : window,
)

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
      fr: { translation: frTranslations },
    },
    ...(initialLanguage ? { lng: initialLanguage } : {}),
    fallbackLng: 'fr',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
